export default __webpack_public_path__ + "static/media/NextSalah.f070ab42.png";